import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

// Start googlemap initialization
const s = document.createElement('script');
s.type = 'text/javascript';
s.setAttribute('src', `${environment.googleMaps.baseUrl}?libraries=places,geometry&key=${environment.googleMaps.apiKey}`);
document.body.appendChild(s);
// End googlemap initialization

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch();
